import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardV2ShareRecommendationsConfigQuery,
	StarterDashboardV2ShareRecommendationsConfigQueryVariables,
} from './shouldLoadShareRecommendations.graphql';
import { StarterDashboardV2ShareRecommendationsConfig } from './shouldLoadShareRecommendations.graphql';

export async function shouldLoadShareRecommendations(utilityContext: UtilityContext) {
	const {
		data: {
			featureConfigs: { starterExperienceShareRecommendations },
		},
	} = await utilityContext.gql.fetch<
		StarterDashboardV2ShareRecommendationsConfigQuery,
		StarterDashboardV2ShareRecommendationsConfigQueryVariables
	>({
		query: StarterDashboardV2ShareRecommendationsConfig,
		rejectOnError: true,
	});

	return starterExperienceShareRecommendations.isEnabled;
}
